module.exports = __webpack_public_path__ + "static/media/NextRound.1676cb28.png";